const bottomSlider = {
  itemsToShow: 5,
  progress: true,
  itemsToSlide: 2,
  infiniteScroll: true,
  breakpoints: {
    1700: {
      itemsToShow: 6
    },
    1264: {
      itemsToShow: 5
    },
    1000: {
      itemsToShow: 4
    },
    600: {
      itemsToShow: 5
    },
    449: {
      itemsToShow: 4
    },
    200: {
      itemsToShow: 3
    }
  }
};

const footerSlider = {
  itemsToShow: 4,
  infiniteScroll: true,
  trimWhiteSpaces: true,
  centerMode: true,
  progress: true,
  autoPlay: true,
  playSpeed: 3500,
  breakpoints: {
    1660: {
      itemsToShow: 6
    },
    1264: {
      itemsToShow: 5
    },
    1000: {
      itemsToShow: 4
    },
    800: {
      itemsToShow: 4
    },
    600: {
      itemsToShow: 3
    },
    400: {
      itemsToShow: 2
    }
  }
};

export { footerSlider, bottomSlider };
